module.exports = __webpack_public_path__ + "img/icon.c512a11b.png";